exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sidenav.collapsed[data-v-026d1fef]{margin-left:-250px}.sidenav[data-v-026d1fef]{-webkit-transition:margin-left .25s ease-out,-webkit-transform .25s ease-out;transition:margin-left .25s ease-out,-webkit-transform .25s ease-out;transition:margin-left .25s ease-out,transform .25s ease-out;transition:margin-left .25s ease-out,transform .25s ease-out,-webkit-transform .25s ease-out;width:250px}", ""]);

// exports
